import { render } from "./App.vue?vue&type=template&id=6f6333e2&scoped=true&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=6f6333e2&scoped=true&lang=css"

import exportComponent from "/vue/cubetrain/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f6333e2"]])

export default __exports__